import { createStyles, makeStyles } from '@material-ui/styles';
import DadosContrato from '../icons/icon-img/dados.png'

export const DadosContratoIcon = () => {
  const useStyles = makeStyles(() => 
    createStyles({
      img: {
        width: '25px',
        height: '25px'
      },
    })
  )
  const classes = useStyles();
  return (
    <>
      <img
      className={classes.img}
      src={DadosContrato} 
      alt="" 
      />
    </>
  );
};
